import { css } from 'styled-components'

import { isDefined } from 'aem-libs-ts/src/utils/common/isDefined'
import { objectKeys } from 'aem-libs-ts/src/utils/common/objectKeys'

import { resolveSizeValue } from './resolveSizeValue'
import { Size } from './size'

export const resolveSizeValues = <StyledProps extends Record<string, number | Size>>(
  props: StyledProps,
  transformMap: Partial<Record<keyof StyledProps, string>>
) => {
  return objectKeys(transformMap)
    .filter(isDefined)
    .filter((key) => isDefined(props[key]))
    .map(
      (key) => css`
        ${transformMap[key]}: ${resolveSizeValue(props[key] as number | Size)};
      `
    )
}
